var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('RoleModal'),_c('LeftMenu'),_c('div',{staticClass:"wrappers"},[(_vm.$store.state.user)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }